document.addEventListener("DOMContentLoaded", function () {


const buttons = document.querySelectorAll(".size-unit");


if(!buttons.length){
return;
}



buttons.forEach(function(button){


button.addEventListener("click",function(){


const target=this.dataset.target;



buttons.forEach(function(btn){

btn.classList.remove("active");

});



this.classList.add("active");




document.querySelectorAll(".unit-table").forEach(function(table){

table.style.display="none";

});



document.getElementById(target).style.display="table";



});


});


});